export function simpleBarAutoScrollHandler (event:any, fetchCondition: boolean, getNextPage: (...args: any) => void) {
    const {scrollHeight, scrollTop, clientHeight} = event.target;
    const isBottomReached = (scrollHeight - Math.round(scrollTop) <= (clientHeight + 50));

    if(isBottomReached && fetchCondition) {
        getNextPage()
    }
}